import { NgModule } from '@angular/core';
import { BlogIndexContainerComponent } from '@innogy/common-ui/blog';
import {
  AccordionContainerComponent,
  AnchorComponent,
  BasicContentWrapperComponent,
  CardContentBlockComponent,
  CommonUiCommonRenderingsModule,
  EqualHeightComponent,
  HorizontalLinksListComponent,
  IconListComponent,
  IconListItemComponent,
  ImageWrapperComponent,
  InfoCardContainerComponent,
  JumbotronContainerComponent,
  ListContainerComponent,
  MultipleLinksListContainerComponent,
  RichTextComponent,
  TimerWidgetWrapperComponent,
  TimerWrapperComponent,
  VideoContainerComponent,
} from '@legacy/common-ui-common-renderings';
import {
  ButtonContainerComponent,
  CommonUiFormsModule,
} from '@innogy/common-ui/forms';
import {
  Colset12Component,
  Colset3333Component,
  Colset336Component,
  Colset39Component,
  Colset444Component,
  Colset48Component,
  Colset66Component,
  ColsetMijn363Component,
  ColsetMijn39Component,
  CommonUiGridsModule,
  DynamicRowComponent,
  RowContainerComponent,
  RowContainerSoloComponent,
} from '@innogy/common-ui/grids';
import {
  BackButtonMobileComponent,
  BackButtonSidebarComponent,
  CommonUiMijnRenderingsModule,
  MijnInformationBlockContainerComponent,
} from '@innogy/common-ui/mijn-renderings';
import {
  CommonUiProductsModule,
  ScGenericOfferContainerComponent,
} from '@innogy/common-ui/products';
import {
  AvailabilityContainerComponent,
  CommonUiServiceComponentsModule,
  FaqContainerComponent,
  HowToQuestionnaireContainerComponent,
  HowToReadBillContainerComponent,
  TaxonomyContainerComponent,
  TopTasksContainerComponent,
} from '@innogy/common-ui/service-components';
import { provideLazyLoad } from '@core/jss-utils';

@NgModule({
  imports: [
    CommonUiFormsModule,
    CommonUiGridsModule,
    CommonUiCommonRenderingsModule,
    CommonUiServiceComponentsModule,
    CommonUiMijnRenderingsModule,
    CommonUiProductsModule,
    provideLazyLoad({
      MijnInformationBlock: MijnInformationBlockContainerComponent,
      Button: ButtonContainerComponent,
      Accordion: AccordionContainerComponent,
      ContentBlock: EqualHeightComponent,
      Video: VideoContainerComponent,
      HorizontalLinksList: HorizontalLinksListComponent,
      MultipleLinksList: MultipleLinksListContainerComponent,
      RichText: RichTextComponent,
      BackButtonSidebar: BackButtonSidebarComponent,
      BackButtonMobile: BackButtonMobileComponent,
      Anchor: AnchorComponent,
      InfoCard: InfoCardContainerComponent,
      TopTasks: TopTasksContainerComponent,
      Availability: AvailabilityContainerComponent,
      Taxonomy: TaxonomyContainerComponent,
      FaqContainer: FaqContainerComponent,
      HowToQuestionnaire: HowToQuestionnaireContainerComponent,
      HowToReadBill: HowToReadBillContainerComponent,
      IconList: IconListComponent,
      IconListItem: IconListItemComponent,
      RowContainer: RowContainerComponent,
      RowContainerSolo: RowContainerSoloComponent,
      SingleColumn: Colset12Component,
      TwoColumn39: Colset39Component,
      TwoColumn48: Colset48Component,
      TwoColumn66: Colset66Component,
      ThreeColumn336: Colset336Component,
      ThreeColumn444: Colset444Component,
      FourColumn3333: Colset3333Component,
      MyEnvironmentGridThreeColumns: ColsetMijn363Component,
      MyEnvironmentGridTwoColumns: ColsetMijn39Component,
      DynamicRow: DynamicRowComponent,
      Image: ImageWrapperComponent,
      BasicContent: BasicContentWrapperComponent,
      Jumbotron: JumbotronContainerComponent,
      List: ListContainerComponent,
      StandaloneProductOverview: ScGenericOfferContainerComponent,
      BlogIndex: BlogIndexContainerComponent,
      CardContentBlock: CardContentBlockComponent,
      Timer: TimerWrapperComponent,
      TimerWidget: TimerWidgetWrapperComponent,
    }),
  ],
})
export class CommonUiLazyModule {}
